import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";

@Component({
	selector: "app-motor-detail",
	templateUrl: "./motor-detail.component.html",
	styleUrls: ["./motor-detail.component.scss"]
})
export class MotorDetailComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Motor;
	@Input()
	shaft: AssemblyConfig.Shaft | AssemblyConfig.MotorShaft;
	@Input()
	raw: APIResults.RawSinglesResult;

	public spectrumoptions?: Highcharts.Options;
	public errormessage: string;

	constructor(private api: ApiService, private charting: ChartingService) {
	}

	async ngOnChanges() {
		if (this.asset && this.component && this.raw) {
			this.spectrumoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetMotorDetail(this.asset.asset_id, this.component.id, this.raw.rawid);
				const markers = result.markers.map(marker => {
					return { title: marker.name, axisvalue: marker.value };
				});
				this.spectrumoptions = this.charting.SpectrumDefaults("Spectrum", "Gs", [
					{ type: "line", name: "Spectrum Analysis", data: result.spectrum },
				], false, markers);
			} catch (err) {
				this.errormessage = "Unable to load motor details";
				console.error("Couldn't load motor details");
				console.log(err);
			}
		}
	}
}
